import { apiClient } from "@/api/api.ts";

export const EvolveWorldview = async (personaId: string, feedback: string) => {
  const response = await apiClient.post(`/api/personality/evolve_worldview`, {
    persona_id: personaId,
    feedback,
  });
  return response.data;
};

export const EvolveContentStrategy = async (
  personaId: string,
  feedback: string,
) => {
  const response = await apiClient.post(
    `/api/personality/evolve_content_strategy`,
    {
      persona_id: personaId,
      feedback,
    },
  );
  return response.data;
};
